import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import TeamRoleCard from "@/modules/Missions/components/Details/ManageTeamRoles/TeamRoleCard.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  GenerateMissionTeamRolesMutationMutation,
  GenerateMissionTeamRolesMutationMutationVariables,
  GenerateMissionTeamRolesMutation,
  MissionLifecycleFragmentFragment,
  MissionStaffingPositionFragmentFragment,
} from "@/gql"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import StaffingPositionActions from "./StaffingPositionActions.vue"
import StaffingPositionDetailsModal from "@/modules/Missions/components/Details/ManageTeamRoles/StaffingPositionDetails/StaffingPositionDetailsModal.vue"
import { Actions } from "@/modules/Missions/components/Details/ManageTeamRoles/constant"


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageTeamRoles',
  props: {
    mission: null,
    refetchQueries: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
  refetchQueries: RefetchQueryDescription
}



const showApplicationDialog = ref(false)
const activePositionId = ref("")

const onRoleClick = (id: string) => {
  activePositionId.value = id
  showApplicationDialog.value = true
}

const isSubmitting = ref(false)

const { mutate } = useMutation()
const { addSuccess } = useNotification()

const onCreateTeam = async () => {
  isSubmitting.value = true

  const result = await mutate<
    GenerateMissionTeamRolesMutationMutation,
    GenerateMissionTeamRolesMutationMutationVariables
  >({
    mutation: GenerateMissionTeamRolesMutation,
    variables: {
      id: props.mission.prn,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result && !result?.data?.generateMissionTeamRoles?.error) {
    addSuccess("Team successfully created")
  }
}

const activeStaffPosition = ref<MissionStaffingPositionFragmentFragment | null>(null)
const staffingPositionAction = ref<string | undefined>(undefined)

const onRoleActionClick = (action: string, position: MissionStaffingPositionFragmentFragment) => {
  if (action === Actions.View) {
    onRoleClick(position.id)
    return
  }
  staffingPositionAction.value = action
  activeStaffPosition.value = position
}

const onCloseAction = () => {
  staffingPositionAction.value = undefined
  activeStaffPosition.value = null
}

const onClosePositionDetails = () => {
  activePositionId.value = ""
  showApplicationDialog.value = false
}

return { __sfc: true,props, showApplicationDialog, activePositionId, onRoleClick, isSubmitting, mutate, addSuccess, onCreateTeam, activeStaffPosition, staffingPositionAction, onRoleActionClick, onCloseAction, onClosePositionDetails, TeamRoleCard, Icon, StaffingPositionActions, StaffingPositionDetailsModal }
}

})